import { createActionCreator } from '../utils/helpers';
import { generateActions } from '../utils/HttpReducerHelper';

import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_CALLBACK,
  LOGOUT,
  LOGOUT_SUCCESS,
  DEMASQUERADE,
  REQUEST_REFRESH,
  REQUEST_LOGIN_BY_SESSION,
  REFRESH_IN_PROGRESS,
  REFRESH_SUCCESS,
  REFRESH_FAILURE,
  REQUEST_INTEGRATION_AUTHORIZATION_URL,
  REQUEST_INTEGRATION_AUTHORIZATION_INVITE_URL,
  REMOVE_TRADE_HISTORY_INTEGRATION_CONNECTED,
  REMOVE_INTEGRATION_CONNECTED,
  REDIRECT_TO_AUTH0_LOGIN,
  SIGN_IN,
  integrationAuthorizationUrl,
} from './types';

export const loginRequest = createActionCreator(LOGIN_REQUEST);
export const loginSuccess = (authResult) => ({
  type: LOGIN_SUCCESS,
  payload: {
    accessToken: authResult.accessToken,
    tokenPayload: authResult.tokenPayload,
    expiresAt: authResult.expiresAt,
  },
});
export const loginFailure = createActionCreator(LOGIN_FAILURE, 'error');
export const loginCallback = createActionCreator(LOGIN_CALLBACK);

export const logout = () => ({
  type: LOGOUT,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const demasquerade = createActionCreator(DEMASQUERADE);

export const requestRefreshToken = createActionCreator(REQUEST_REFRESH);
export const requestLoginBySession = createActionCreator(REQUEST_LOGIN_BY_SESSION, 'redirectUrl');
export const refreshTokenInProgress = createActionCreator(REFRESH_IN_PROGRESS);
export const refreshTokenSuccess = createActionCreator(REFRESH_SUCCESS, 'payload');
export const refreshTokenFailure = createActionCreator(REFRESH_FAILURE);

export const redirectToAuth0Login = createActionCreator(REDIRECT_TO_AUTH0_LOGIN);

export const removeIntegrationConnected = createActionCreator(
  REMOVE_INTEGRATION_CONNECTED,
  'providerId',
  'businessId',
  'caseId',
  'isFundingCase',
  'promise',
);
export const requestIntegrationAuthorizationUrl = createActionCreator(
  REQUEST_INTEGRATION_AUTHORIZATION_URL,
  'integration',
  'context',
  'objectId',
  'redirect',
  'promise',
);
export const removeTradeHistoryIntegrationConnected = createActionCreator(
  REMOVE_TRADE_HISTORY_INTEGRATION_CONNECTED,
  'integration',
  'context',
  'objectId',
  'promise',
);
export const requestIntegrationAuthorizationInviteUrl = createActionCreator(
  REQUEST_INTEGRATION_AUTHORIZATION_INVITE_URL,
  'integration',
  'context',
  'objectId',
  'promise',
);

const integrationAuthorizationUrlHTTPAction = generateActions(integrationAuthorizationUrl);
export const requestIntegrationAuthorizationUrlInProgress =
  integrationAuthorizationUrlHTTPAction.request;
export const requestIntegrationAuthorizationUrlSuccess =
  integrationAuthorizationUrlHTTPAction.success;
export const requestIntegrationAuthorizationUrlFailure =
  integrationAuthorizationUrlHTTPAction.failure;

export const signIn = createActionCreator(SIGN_IN.request, 'email', 'password');
export const signInSuccess = createActionCreator(SIGN_IN.success);
export const signInFailure = createActionCreator(SIGN_IN.failure, 'error');
